import React, { useCallback, useState } from 'react';

import type { IDragDropZoneProps } from '~/components/DragDropZone';
import DragDropZone from '~/components/DragDropZone';
import type { Attachment } from '~/data/schemas/attachment';
import { uploadAttachment } from '~/data/uploadAttachment';

interface IAttachmentUploaderProps extends Pick<
  IDragDropZoneProps,
  'acceptedFileTypesLabel' | 'fileSizeLimit' | 'acceptedFileTypes'
> {
  onFilesUploaded: (attachment: Attachment[]) => void;
}

const AttachmentUploader: React.FC<IAttachmentUploaderProps> = ({ onFilesUploaded, ...rest }) => {
  const [isUploading, setIsUploading] = useState(false);
  const handleFileUpload = useCallback(
    async (files: File[]) => {
      if (files.length < 1) {
        return;
      }

      setIsUploading(true);

      try {
        const uploadPromises = files.map((file) =>
          uploadAttachment({
            file,
            name: file.name,
            fileType: 'pdf',
          }),
        );

        const attachments = await Promise.all(uploadPromises);
        onFilesUploaded(attachments);
      } finally {
        setIsUploading(false);
      }
    },
    [onFilesUploaded],
  );

  return <DragDropZone {...rest} onFileSelected={handleFileUpload} loading={isUploading} />;
};

export default AttachmentUploader;
